module.exports = __webpack_public_path__ + "media/common/images/cta/steph-4e33c4cbe16743f6f372aaee4a55eb75.jpeg";